import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { navigationService } from '../../services/navigation.service';
import { NavItem } from '../../models/navItem';
import { Icon } from '@mui/material';

const NavSitemap: React.FC = () => {
  const [menuItems, setMenuItems] = useState<NavItem[]>([]);

  const location = "sitemap";

  const fetchMenuItems = async () => {
    const items = await navigationService.getNavigationItems(location);
    setMenuItems(items);
  };

  useEffect(() => {
    fetchMenuItems();
  }, [location]);

  return (
    <nav className="navigation nav-sitemap" role="navigation" aria-label="Sitemap navigatie">
      <div className="container">
        <div className="row">
          {menuItems.map(({ path, icon, name, children }) => (
            <div key={name} className="col-md-4 col-lg-4 mb-4">
              {path ? (
                <>
                  {path.startsWith('http') ? (
                    <a href={path} target="_blank" rel="noopener noreferrer">{name}</a>
                  ) : (
                    <Link to={path}>{name}</Link>
                  )}
                </>
              ) : (
                <div className="title">
                  {icon && <Icon>{icon}</Icon>}
                  <span>{name}</span>
                </div> // Render as section title if no path
              )}
              {children && children.length > 0 && (
                <ul>
                  {children.map(({ path, name }) => (
                    <li key={path}>
                      {path.startsWith('http') ? (
                        <a href={path} target="_blank" rel="noopener noreferrer">{name}</a>
                      ) : (
                        <Link to={path}>{name}</Link>
                      )}
                  </li>
                  ))}
                </ul>
              )}
            </div>
            ))}
        </div>
      </div>
    </nav>
  );
}

export default NavSitemap;
